<div class="number-spinner">
  <button class="btn btn-sm me-1" [ngClass]="{'btn-primary': !(showDeleteIcon && value == minValue), 'btn-danger': (showDeleteIcon && value == minValue)}" type="button" (click)="incrementValue(-1)"
    longPress (mouseLongPress)="incrementValue(-1)">
    <i class="fa fas fa-minus" *ngIf="!(showDeleteIcon && value == minValue)"></i>
    <i class="fa fas fa-trash" *ngIf="(showDeleteIcon && value == minValue)"></i>
  </button>

  <input type="number" [min]="minValue" [max]="maxValue" [(ngModel)]="value" (change)="onInputChange($event)" (keypress)="onlyAllowNumbers($event)" class="form-control me-1 number-input">

  <button class="btn btn-sm btn-primary" type="button" (click)="incrementValue(1)" longPress (mouseLongPress)="incrementValue(1)">
    <i class="fa fas fa-plus"></i>
  </button>
</div>